import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import { withStyles } from '@material-ui/core/styles';

import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import Slide from '@material-ui/core/Slide';
import IconButton from '@material-ui/core/IconButton';
import ClearIcon from '@material-ui/icons/Clear';

import GridContainer from 'Common/Grid/GridContainer.jsx';
import ItemGrid from 'Common/Grid/ItemGrid.jsx';
import lightboxStyle from './styles.jsx';

function Transition(props) {
    return <Slide direction="up" unmountOnExit {...props} />;
}

@withStyles(lightboxStyle)
export default class Lightbox extends PureComponent {
    /**
     * PropTypes
     */
    static propTypes = {
        classes: PropTypes.object.isRequired,
        children: PropTypes.node,
        text: PropTypes.string,
        preFormattedText: PropTypes.bool,
        title: PropTypes.string,
        actions: PropTypes.any,
        isOpen: PropTypes.bool.isRequired,
        handleClose: PropTypes.func.isRequired,
        actionsClass: PropTypes.string,
    };

    /**
     * @type {Object}
     */
    static defaultProps = {
        actions: null,
        preFormattedText: false,
    };

    render() {
        const { classes, children, text, preFormattedText, title, actions, isOpen, handleClose, actionsClass, ...dialogProps } = this.props;

        return (
            <Dialog
                open={isOpen}
                onClose={handleClose}
                TransitionComponent={Transition}
                aria-labelledby="form-dialog-title"
                fullWidth
                keepMounted
                classes={{ paper: classes.paper }}
                {...dialogProps}
            >
                {title && (
                    <DialogTitle id="form-dialog-title" disableTypography>
                        <GridContainer>
                            <ItemGrid md={11} className={classes.title}>
                                <FormattedMessage id={title}/>
                            </ItemGrid>
                            <ItemGrid md={1}>
                                <IconButton aria-label="Remove" onClick={handleClose}>
                                    <ClearIcon />
                                </IconButton>
                            </ItemGrid>
                        </GridContainer>
                    </DialogTitle>
                )}
                <DialogContent className={classes.content}>
                    {text && (
                        <DialogContentText>
                            { preFormattedText ? text : <FormattedMessage id={text} /> }
                        </DialogContentText>
                    )}
                    {children}
                </DialogContent>
                {actions && <DialogActions className={actionsClass}>{actions}</DialogActions>}
            </Dialog>
        );
    }
}



// WEBPACK FOOTER //
// ./src/common/Lightbox/Lightbox.jsx